import React, { PropsWithChildren, ReactElement } from 'react'
import { Flex, Text, ThemeUIStyleObject } from 'theme-ui'
import { Button, Svg } from 'ui'
import { navigate } from 'gatsby'
import CheckMarkIcon from 'images/organization/industries/startups/checkmark.svg'

export default function ScalablePricingPlansContainer({
  children,
}: PropsWithChildren): ReactElement {
  return (
    <Flex
      className="ios-scrolling-glitches-fix"
      data-testid="scalable-pricing-plans"
      sx={{
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '2.1rem',
        position: 'relative',
        backgroundColor: 'blue800',
        borderColor: 'blueYonder20',
        px: ['1.6rem', '1.6rem', 0],
      }}
    >
      <Flex
        sx={{
          backgroundColor: 'blue80',
          width: '76rem',
          zIndex: 'pricingModal',
          border: '1px solid',
          borderColor: 'blueYonder20',
          borderRadius: '1rem',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
        }}
      >
        {children}

        <Flex
          sx={{
            flexDirection: ['column', 'row'],
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderTop: '1px solid',
            borderColor: 'blueYonder20',
            gap: ['1.6rem', 0],
            py: ['2.4rem', '1.6rem'],
            px: '2.4rem',
          }}
        >
          <Text
            variant="size15Weight600Line138Letter03"
            sx={{
              textAlign: 'center',
              color: 'lightSteelBlue',
            }}
          >
            Got a question in mind?
          </Text>

          <Button
            ariaLabel="Learn more"
            name="Learn more"
            variant="roundedSecondary"
            sx={{ width: 'auto', height: '3.1rem' }}
            onClick={() => navigate('/contact')}
          >
            <Text variant="size14Weight600Line138">Contact us</Text>
          </Button>
        </Flex>
      </Flex>
    </Flex>
  )
}

export function PricingFeatures({
  title,
  description,
  sx,
}: {
  title: string
  description: string
  sx?: ThemeUIStyleObject
}): ReactElement {
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        alignItems: 'center',
        py: '1.6rem',
        gap: '0.8rem',
        flex: 1,
        ...sx,
      }}
    >
      <Svg svg={CheckMarkIcon} descriptiveText="checkmark" />
      <Text variant="size15Weight600Line138Letter03" sx={{ color: 'aliceBlue' }}>
        {title}
      </Text>
      <Text variant="size14Weight400Line138Letter028" sx={{ color: 'lightSteelBlue' }}>
        {description}
      </Text>
    </Flex>
  )
}
